'use client';

import Link from '@eliadmin/core/src/components/link';

import type { CategoriesEntity } from '@eliadmin/core/src/api/general/types/general-layout-types';

import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetTitle,
  SheetTrigger,
} from '@eliadmin/core/src/components/ui/sheet';

import { HEADER_CONFIG } from '@eliadmin/core/src/constants/header-config';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { getSafeHref, isRelativeHref } from '@eliadmin/core/src/utils/url-utils';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { getControlLabels } from '../control-labels';

export type MobileSidebarProps = {
  className?: {
    trigger?: string;
    content?: string;
    firstSeparator?: string;
    menuList?: string;
    menuLink?: string;
    menuGroup?: string;
    menuSeparator?: string;
    buttonWrapper?: string;
    button?: string;
    iconsWrapper?: string;
    icon?: string;
  };
  side?: 'right' | 'left' | 'bottom' | 'top';
  firstSeparator?: boolean;
  menu?: {
    type: 'page';
    name: string;
    path?: string;
  }[];
  menuArrow?: boolean;
  menuSeparator?: boolean;
  categories?: CategoriesEntity[];
};

const MobileSidebar = (props: MobileSidebarProps) => {
  const locale = useLocaleStore(state => state.currentLocale);
  const menuLabel = getControlLabels(locale).menu;
  return (
    <>
      <Sheet>
        <SheetTrigger
          aria-label={menuLabel}
          className={cn('text-white', 'ea-mobile-sidebar__trigger', props.className?.trigger)}
        >
          {HEADER_CONFIG?.sidebar?.triggerIcon}
        </SheetTrigger>
        <SheetContent
          aria-describedby={undefined}
          side={'left'}
          className={cn(
            'flex w-[340px] flex-col items-start justify-start border-none bg-white p-8 pt-20 shadow-none',
            'ea-mobile-sidebar__content',
            props.className?.content,
          )}
          closeIcon={{
            wrapper:
              'right-4 top-4 w-8 h-8 flex items-center justify-center rounded-full bg-primary',
            icon: 'text-white h-6 w-6 font-bold',
          }}
        >
          <SheetTitle className="sr-only">{menuLabel}</SheetTitle>
          {!!props.menu && (
            <div className="flex flex-col gap-6">
              {props.menu?.map((item, index) => {
                const Comp = item.path
                  ? isRelativeHref(getSafeHref(item.path))
                    ? Link
                    : 'a'
                  : 'span';
                return (
                  <SheetClose key={index} asChild>
                    <Comp
                      href={item.path ? getSafeHref(item.path) : (undefined as any)}
                      className="flex w-full"
                      prefetch={false}
                    >
                      <div className={cn('text-lg font-bold', 'text-foreground')}>{item.name}</div>
                    </Comp>
                  </SheetClose>
                );
              })}
            </div>
          )}
        </SheetContent>
      </Sheet>
    </>
  );
};

export default MobileSidebar;
